<mat-card style="box-shadow:none; padding: 0px;" [class.mat-elevation-z1]="'true'">
    <mat-card-header style="margin-left: -24px; margin-top: -24px !important; margin-right: -24px;">
      <span mat-card-avatar>
        <mat-icon>work</mat-icon>
      </span>
      <mat-card-title>Work Split</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
  
    <mat-dialog-content class="dialog-content" style="padding-top: 20px; width: 600px;">
      <div class="agents">
        <h4>Select Agents:</h4>
        <div *ngFor="let agent of activeAgents" style="margin-bottom: 10px;">
          <mat-checkbox [value]="agent.id" [(ngModel)]="agent.selected" (change)="onAgentSelection($event, agent.id)">
            {{ agent.name }}
          </mat-checkbox>
        </div>
      </div>
  
      <div class="categories">
        <h4>Select Category:</h4>
        <mat-radio-group [(ngModel)]="selectedCat">
          <mat-radio-button *ngFor="let category of categories" [value]="category.value" style="display: block;">
            {{ category.label }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </mat-dialog-content>



    <mat-dialog-actions aling="end">
        <button style="font-size: 10px;
    margin-right: 5px;
    scale: 1;
    background: #bf1e2e;
    color: white;
    border-radius: 0px;
    text-shadow: none;
    box-shadow: none;
    flex: 1 1 100%;
    box-sizing: border-box;
    max-width: 50px;
    cursor: pointer;
    transition: background-color 0.3s;
    box-shadow: none !important;" mat-raised-button (click)="onCancelClick()">Cancel</button>
        <button style="font-size: 10px;
    margin-right: 5px;
    scale: 1;
    background: #bf1e2e;
    color: white;
    border-radius: 0px;
    text-shadow: none;
    box-shadow: none;
    flex: 1 1 100%;
    box-sizing: border-box;
    max-width: 50px;
    cursor: pointer;
    transition: background-color 0.3s;
    box-shadow: none !important;" mat-raised-button (click)="onSaveClick()">Save</button>
    </mat-dialog-actions>
</mat-card>
